export default "__VITE_ASSET__C$VDPvI___"